import _ from "lodash";
import { useCallback, useMemo, useState } from "react";
import { useLazyQuery } from "@apollo/client";

import { errorSwal, warningSwal } from "../../../helper/sweetalert";
import PriceOptionsModal from "./PriceOptionsModal";
import ProductCardList from "./ProductCardList";
import ProductTableList from "./ProductTableList";
import useScanDetection from "use-scan-detection";
import { GET_SHOP } from "../../../apollo/shop/Query";

import { SCAN_PRODUCT } from "../../../apollo/product/query";
import { SHOP_SETTING_KEY, USER_KEY } from "../../../const";

function Product({
  _skip,
  _limit,
  isTableList,
  selectedPrice,
  products,
  cartDatas,
  activeCart,
  updateOrder,
  addOrder,
  setCartDatas,
  originProducts, 
  optionPrice,
  productLoading,
  productDatas,
  shopData
}) {
  const setting = useMemo(() => {
    return JSON.parse(localStorage.getItem(SHOP_SETTING_KEY));
  }, []);
  const shopId = JSON.parse(localStorage.getItem(USER_KEY))?.data?.shop?.id;
  const [showPriceOptionModal, setShowPriceOptionModal] = useState(false);
  const [selectedProduct, setSelectedProduct] = useState([]);
  const [selectedProductPrice, setSelectedProductPrice] = useState(0);

  const [getProductFromBarcode] = useLazyQuery(SCAN_PRODUCT);

  const getScanProduct = useCallback(async (barCode) => {
    if (!barCode) return;
    const respon = await getProductFromBarcode({
      variables: {
        where: {
          barCode: barCode,
          shop: shopId,
          isDeleted: false
        },
      },
    });

    return onSelectProduct(respon?.data?.stocksByBarcode);
  });

  // ==========> useEffect <==========

  const _getScanProduct = useCallback(async (barCode) => {
    if (!barCode) return;
    const respon = await getProductFromBarcode({
      variables: {
        where: {
          barCode: barCode,
          shop: shopId,
          isDeleted: false
        },
      },
    });

    return onSelectProduct(respon?.data?.stocksByBarcode);
  }, [getProductFromBarcode, shopId]);

  useScanDetection({
    // onComplete: getScanProduct,
    onComplete: (barCode) => {
      // Filter out any "Shift" strings that might appear in the barcode
      const cleanBarCode = barCode.replace(/Shift/g, '');
      // console.log("Original barCode:", barCode);
      // console.log("Cleaned barCode:", cleanBarCode);
      getScanProduct(cleanBarCode);
    },
    minLength: 0,
  });

  const onSelectProduct = useCallback(
    (product) => {
      if (cartDatas?.length <= 0) {
        errorSwal("ກະລຸນາເພີ່ມໃບບີນ");
        return;
      }

      if (_.isEmpty(product)) return;
      setSelectedProduct(product);

      const checkOrder = cartDatas?.flatMap((item) => item?.data?.orders) || [];
      const filteredOrders = checkOrder.filter(
        (order) => order.product === product.id
      );
      const sumTotal = filteredOrders.reduce(
        (total, order) => total + order.amount,
        0
      );

      // function out stock update 7/31/2024
      const isLessStocks = shopData?.shop?.isLessStocks;

      if (!isLessStocks || isLessStocks) {
        if (!isLessStocks) {
          if (sumTotal >= product?.amount) {
            errorSwal(`ສິນຄ້າ  ${product?.name} ໝົດສະຕ໋ອກ`);
            return;
          }
        }
      }

      const _check = checkedProductSelected(product);

      // split amount order setting
      const {splitAmountOrder} = setting;
      if (!_check || splitAmountOrder || shopData?.shop?.id === '678db8f1942eb6002c1f40cd') {
        addOrder({ product, productPrice: 0 });
      } else {
        updateOrder({
          product,
          productId: product?.id,
          isAdded: true,
          changeValue: 0,
        });
      }
    },
    [cartDatas, addOrder, updateOrder, shopData]
  );

  const onSelectOptionPrice = (product) => {
    setSelectedProduct(product);
    if (cartDatas?.length <= 0) return warningSwal("ກະລຸນາເພີ່ມໃບບີນ");

    let _check = checkedProductSelected(product);

    if (!_check && product?.priceOptions) {
      setShowPriceOptionModal(true);
      return;
    }
    return setShowPriceOptionModal(true);
  };

  const checkedProductSelected = (product) => {
    let _check = false;
    const cartData = _.find(cartDatas, { label: activeCart });
    cartData?.data?.orders?.forEach((productId) => {
      if (product?.id === productId?.product) _check = true;
    });
    return _check;
  };

  return (
    <div>
      {!isTableList ? (
        <ProductCardList
          products={products}
          onSelectProduct={onSelectProduct}
          checkedProductSelected={checkedProductSelected}
          selectedPrice={selectedPrice}
          optionPrice={optionPrice}
          productLoading={productLoading}
          productDatas={productDatas}
        />
      ) : (
        <ProductTableList
          _skip={_skip}
          _limit={_limit}
          productLoading={productLoading}
          productDatas={productDatas}
          products={products}
          onSelectProduct={onSelectProduct}
          setShowPriceOptionModal={setShowPriceOptionModal}
          checkedProductSelected={checkedProductSelected}
          onSelectOptionPrice={onSelectOptionPrice}
          selectedPrice={selectedPrice}
          optionPrice={optionPrice}
        />
      )}
      <PriceOptionsModal
        addOrder={addOrder}
        selectedProductPrice={selectedProductPrice}
        setSelectedProductPrice={setSelectedProductPrice}
        selectedProduct={selectedProduct}
        setSelectedProduct={setSelectedProduct}
        showPriceOptionModal={showPriceOptionModal}
        cartDatas={cartDatas}
        setCartDatas={setCartDatas}
        setShowPriceOptionModal={setShowPriceOptionModal}
        activeCart={activeCart}
      />
    </div>
  );
}

export default Product;
